<template>
  <div class="pb-4">
    <b-card>
      <div class="d-flex align-items-center">
        <h4 class="pr-1">เพิ่มข้อมูล FCL</h4>
        <b-button variant="primary" v-b-modal.add-fcl>เพิ่ม</b-button>
      </div>
      <hr>

      <!-- fcl 20 -->
      <div class="pb-4">
        <div class="d-flex align-items-center pb-1">
          <h4 class="pr-1">FCL 20'</h4>
          <v-select
            class="px-0 col-md-3 col-12"
            v-model="selFclDate"
            :options="dateFCL"
            label="date"
            @input="getFCL20(selFclDate), getFCL40(selFclDate)"
          >
          </v-select>
        </div>
        <b-table
          :items="Fcl20List"
          :fields="Fcl20Fields"
          responsive
          class="position-relative"
          table-class="table-sm-responsive text-nowrap"
        >
          <template #cell(fcL_OFGP)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_EBS_CIC_ECRS)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_OF_EBS_CIC_ECRS)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_OF_EBS_CIC_ECRS_THB)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_LocalChargeBKK)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_ExportCharge)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_Total)="data">
            {{format_price(data.value)}}
          </template>
        </b-table>
      </div>

      <!-- fcl 40 -->
      <div>
        <h4>FCL 40'</h4>
        <b-table
          :items="Fcl40List"
          :fields="Fcl40Fields"
          responsive
          class="position-relative"
          table-class="table-sm-responsive text-nowrap"
        >
          <template #cell(fcL_OFGP)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_EBS_CIC_ECRS)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_OF_EBS_CIC_ECRS)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_OF_EBS_CIC_ECRS_THB)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_LocalChargeBKK)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_ExportCharge)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(fcL_Total)="data">
            {{format_price(data.value)}}
          </template>
        </b-table>
      </div>
    </b-card>

    <!-- lcl -->
    <b-card>
      <div class="d-flex align-items-center">
        <h4 class="pr-1">เพิ่มข้อมูล LCL</h4>
        <b-button variant="primary" v-b-modal.add-lcl>เพิ่ม</b-button>
      </div>
      <hr>
      <v-select
        class="px-0 pb-1 col-md-3 col-12"
        v-model="selLclDate"
        :options="dateLCL"
        label="date"
        @input="getLCL(selLclDate)"
      >
      </v-select>
      <b-table
          :items="LclList"
          :fields="LclFields"
          responsive
          class="position-relative"
          table-class="table-sm-responsive text-nowrap"
        >
          <template #cell(lcL_LocalChargeBKK)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(lcL_ExportCharge)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(lcL_Total)="data">
            {{format_price(data.value)}}
          </template>
        </b-table>
    </b-card>

    <!-- fcl charge -->
    <b-card>
      <div class="d-flex align-items-center">
        <h4 class="pr-1">เพิ่มข้อมูล FCL Charges</h4>
        <b-button variant="primary" v-b-modal.add-charge>เพิ่ม</b-button>
      </div>
      <hr>
      <div class="d-flex align-items-center pb-1">
        <h4 class="pr-1">FCL Charge 20'</h4>
        <v-select
          class="px-0 col-md-3 col-12"
          v-model="selFclChargeDate"
          :options="dateFCLCharge"
          label="date"
          @input="getFcl20Charge(selFclChargeDate), getFcl40Charge(selFclChargeDate)"
        >
        </v-select>
      </div>
      <b-table
        :items="Fcl20ChargeList"
        :fields="FclChargeFields"
        responsive
        class="position-relative"
        table-class="table-sm-responsive text-nowrap"
      >
        <template #cell(fcL_THC)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_Cleaning)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_SealFee)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_TelexFeePerSet)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_HandingPerSet)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_DOPerSet)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_DryContainer)="data">
          {{format_price(data.value)}}
        </template>
         <template #cell(fcL_ServiceChargePerShipment)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_ApplyPyotoCOPerShipment)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_ApplyFormEPerShipment)="data">
          {{format_price(data.value)}}
        </template>
      </b-table>

      <div class="pb-1 pt-4">
        <h4 class="pr-1">FCL Charge 40'</h4>
      </div>
      <b-table
        :items="Fcl40ChargeList"
        :fields="FclChargeFields"
        responsive
        class="position-relative"
        table-class="table-sm-responsive text-nowrap"
      >
        <template #cell(fcL_THC)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_Cleaning)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_SealFee)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_TelexFeePerSet)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_HandingPerSet)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_DOPerSet)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_DryContainer)="data">
          {{format_price(data.value)}}
        </template>
         <template #cell(fcL_ServiceChargePerShipment)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_ApplyPyotoCOPerShipment)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(fcL_ApplyFormEPerShipment)="data">
          {{format_price(data.value)}}
        </template>
      </b-table>
    </b-card>

     <!-- lcl charge -->
    <b-card>
      <div class="d-flex align-items-center">
        <h4 class="pr-1">เพิ่มข้อมูล LCL Charges</h4>
        <b-button variant="primary" v-b-modal.add-lcl-charge>เพิ่ม</b-button>
      </div>
      <hr>
      <v-select
        class="px-0 pb-1 col-md-3 col-12"
        v-model="selLclChargeDate"
        :options="dateLCLCharge"
        label="date"
        @input="getLclCharge(selLclChargeDate)"
      >
      </v-select>

      <b-table
        :items="LclChargeList"
        :fields="LclChargeFields"
        responsive
        class="position-relative"
        table-class="table-sm-responsive text-nowrap"
      >
        <template #cell(lcL_THCPerCBM)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_CFSPerCBM)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_StatusFeePerCBM)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_CleaningPerCBM)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_PCSPerCBM)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_DOPerSet)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_SurrenderBLPerSet)="data">
          {{format_price(data.value)}}
        </template>
         <template #cell(lcL_HCPerShipment)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_DryContainerPerShipment)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_ServiceChargePerShipment)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_ApplyPyotoCOPerShipment)="data">
          {{format_price(data.value)}}
        </template>
        <template #cell(lcL_ApplyFormEPerShipment)="data">
          {{format_price(data.value)}}
        </template>
      </b-table>
    </b-card>

    <!-- add fcl -->
    <b-modal
      id="add-fcl"
      title="FCL"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <b-form >
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">POL : </b-col>
          <b-col class="col-md-9 col-12">
            <v-select
              class="px-0 col-12"
              v-model="pol"
              :options="polList"
              label="city"
            ></v-select>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1 ">
          <b-col class="col-md-3 col-12">POD : </b-col>
          <b-col class="col-md-9 col-12">
            <v-select
              class="px-0 col-12"
              v-model="pod"
              :options="podList"
              label="city"
            ></v-select>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">O/F 20'/40' GP : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="ofGP" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">EBS+CIC+ECRS : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="ebsCicEcrs" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">O/F 20'/40' USD : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="ofUsd" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">O/F 20'/40' THB : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="ofThb" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">LOCAL CHARGES AT BKK(THB) : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="chargeBkk" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">SHIPPING SEA EXPORT CHARGES (THB) : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="chargeSea" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">ราคา ณ วันที่ : </b-col>
          <b-col class="col-md-9 col-12">
            <flat-pickr v-model="priceDate" class="form-control" :config="datePickerConfig"/>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12"></b-col>
          <b-col class="col-md-9 col-12">
            <b-form-radio-group
              v-model="fclType"
              :options="fclTypeList"
              text-field="label"
              value-field="id"
            />
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button
            variant="primary"
            @click="addFcl"
            :disabled="this.loadBtnAdd == false"
          >
            <b-spinner v-if="this.loadBtnAdd == false" small />
            บันทึก
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- add lcl -->
    <b-modal
      id="add-lcl"
      title="LCL"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <b-form >
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">POL : </b-col>
          <b-col class="col-md-9 col-12">
            <v-select
              class="px-0 col-12"
              v-model="pol"
              :options="polLclList"
              label="city"
            ></v-select>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1 ">
          <b-col class="col-md-3 col-12">POD : </b-col>
          <b-col class="col-md-9 col-12">
            <v-select
              class="px-0 col-12"
              v-model="pod"
              :options="podList"
              label="city"
            ></v-select>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">O/F(THB) : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="ofThb" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">LOCAL CHARGES AT BKK(THB) : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="chargeBkk" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">SHIPPING SEA EXPORT CHARGES(THB) : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="chargeSea" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">ราคา ณ วันที่ : </b-col>
          <b-col class="col-md-9 col-12">
            <flat-pickr v-model="priceDate" class="form-control" :config="datePickerConfig"/>
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button
            variant="primary"
            @click="addLcl"
            :disabled="this.loadBtnAdd == false"
          >
            <b-spinner v-if="this.loadBtnAdd == false" small />
            บันทึก
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- add fcl charge -->
    <b-modal
      id="add-charge"
      title="Charge FCL"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <b-form>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">THC : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="thc" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Cleaning : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="cleaning" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Seal Fee : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="sealFee" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Telex Fee : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="telexFee" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Handing : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="handing" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">D/O : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="doC" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Customs Clearance Dry Container (BKK) : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="dryContainer" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Service Charge : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="serviceCharge" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Apply Pyoto / Apply C/O : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="applyPyotoCO" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Apply Form E : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="applyFormE" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">ราคา ณ วันที่ : </b-col>
          <b-col class="col-md-9 col-12">
            <flat-pickr v-model="priceDateCharge" class="form-control" :config="datePickerConfig"/>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12"></b-col>
          <b-col class="col-md-9 col-12">
            <b-form-radio-group
              v-model="fclType"
              :options="fclTypeList"
              text-field="label"
              value-field="id"
            />
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button
            variant="primary"
            :disabled="this.loadBtnAdd == false"
            @click="addFCLCharge()"
          >
            <b-spinner v-if="this.loadBtnAdd == false" small />
            บันทึก charge
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- add lcl charge -->
    <b-modal
      id="add-lcl-charge"
      title="Charge LCL"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <b-form >
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">THC : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="thc" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">CFS : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="cfs" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Status Fee : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="statusFee" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Cleaning : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="cleaning" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">PCS : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="pcs" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">D/O : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="doC" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Surrender B/L : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="surrenderBL" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">H/C : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="hc" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Customs Clearance Dry Container (BKK) : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="dryContainer" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Service Charge : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="serviceCharge" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Apply Pyoto / Apply C/O : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="applyPyotoCO" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">Apply Form E : </b-col>
          <b-col class="col-md-9 col-12">
            <b-form-input v-model="applyFormE" @keypress="isNumberWithDot($event)"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-md-3 col-12">ราคา ณ วันที่ : </b-col>
          <b-col class="col-md-9 col-12">
            <flat-pickr v-model="priceDateCharge" class="form-control" :config="datePickerConfig"/>
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button
            variant="primary"
            :disabled="this.loadBtnAdd == false"
            @click="addLCLCharge()"
          >
            <b-spinner v-if="this.loadBtnAdd == false" small />
            บันทึก charge
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BFormFile, BButton, BTable, BFormInput, BModal, VBModal, BRow, BCol, BForm, BFormRadioGroup,
  BDropdown, BDropdownItem, BDropdownDivider, BSpinner
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { formatDate_dmy, formatDate_thaiToEng, formatDate_eng, format_price } from '@/views/global_function.js'
import { isNumberWithDot } from '@/views/global_function.js'
import { taobaoService_dotnet } from '@/views/global'
import axios from 'axios'
import { token_api, header_token } from '@/views/token'
export default {
  name: 'Taobao2youUpload',

  components: {
    BCard, BFormFile, BButton, BTable, BFormInput, BModal, VBModal, BRow, BCol, BForm, BFormRadioGroup,
    BDropdown, BDropdownItem, BDropdownDivider, BSpinner, vSelect, flatPickr,
  },

  directives: {
    'b-modal': VBModal,
    Ripple,
  },

  data() {
    return {
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },
      priceDate: new Date(),
      pol: null,
      polList: [
        { city: 'HONGKONG' },
        { city: 'SHEKOU,SHENZHEN' },
        { city: 'NANSHA,GUANGZHOU' },
        { city: 'HUANGPU' },
        { city: 'FOSHAN /SHUNDE' },
        { city: 'JIANGMEN /ZHONGSHAN' },
        { city: 'SHANTOU' },
        { city: 'ZHANJIANG' },
        { city: 'XIAMEN' },
        { city: 'NINGBO' },
        { city: 'SHANGHAI' },
        { city: 'QINGDAO' },
        { city: 'DALIAN' },
        { city: 'NANJING' },
        { city: 'TIANJIN' },
      ],
      polLclList: [
        { city: 'HONGKONG' },
        { city: 'SHENZHEN' },
        { city: 'GUANGZHOU' },
        { city: 'ZHONGSHAN/ZHUHAI/JIANGMEN/SHUNDE' },
        { city: 'XIAMEN' },
        { city: 'NINGBO' },
        { city: 'SHANGHAI' },
        { city: 'LIANYUNGANG' },
        { city: 'QINGDAO' },
        { city: 'TIANJIN' },
        { city: 'DALIAN' },
      ],
      pod: null,
      podList: [
        { city: 'BKK PAT' },
      ],
      ofGP: null,
      ebsCicEcrs: null,
      ofUsd: null,
      ofThb: null,
      chargeBkk: null,
      chargeSea: null,
      container: null,
      containerTypeList: [
        { id: 1, label: "LCL" },
        { id: 2, label: "FCL"  }
      ],

      fclType: null,
      fclTypeList: [
        { id: "20", label: "20' DC" },
        { id: "40", label: "40' DC"  }
      ],

      Fcl20List:[],
      Fcl20Fields: [
        { key: 'fcL_POL', label: 'POL', thClass: 'text-center' },
        { key: 'fcL_POD', label: 'POD', thClass: 'text-center' },
        { key: 'fcL_OFGP', label: 'O/F 20 GP (USD)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_EBS_CIC_ECRS', label: "EBS+CIC+ECRS 20'DC (USD)", thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_OF_EBS_CIC_ECRS', label: "O/F EBS+CIC+ECRS 20'DC/20HQ (USD)", thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_OF_EBS_CIC_ECRS_THB', label: "O/F EBS+CIC+ECRS 20'DC (THB)", thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_LocalChargeBKK', label: 'LOCAL CHARGES AT BKK (THB)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_ExportCharge', label: 'SHIPPING SEA EXPORT CHARGES (THB)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_Total', label: 'Total (THB)', thClass: 'text-right', tdClass: 'text-right' },
      ],

      Fcl40List:[],
      Fcl40Fields: [
        { key: 'fcL_POL', label: 'POL', thClass: 'text-center' },
        { key: 'fcL_POD', label: 'POD', thClass: 'text-center' },
        { key: 'fcL_OFGP', label: 'O/F 40 GP (USD)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_EBS_CIC_ECRS', label: "EBS+CIC+ECRS 40'DC (USD)", thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_OF_EBS_CIC_ECRS', label: "O/F EBS+CIC+ECRS 40'DC/40HQ (USD)", thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_OF_EBS_CIC_ECRS_THB', label: "O/F EBS+CIC+ECRS 40'DC (THB)", thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_LocalChargeBKK', label: 'LOCAL CHARGES AT BKK (THB)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_ExportCharge', label: 'SHIPPING SEA EXPORT CHARGES (THB)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_Total', label: 'Total (THB)', thClass: 'text-right', tdClass: 'text-right' },
      ],

      LclList:[],
      LclFields: [
        { key: 'lcL_POL', label: 'POL', thClass: 'text-center' },
        { key: 'lcL_POD', label: 'POD', thClass: 'text-center' },
        { key: 'lcL_Ton_Volume', label: 'ปริมาตร or น้ำหนัก', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'lcL_OF_THB', label: 'O/F (THB/RT)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_LocalChargeBKK', label: 'LOCAL CHARGES AT BKK (THB)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_ExportCharge', label: 'SHIPPING SEA EXPORT CHARGES (THB)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_Total', label: 'Total (THB)', thClass: 'text-right', tdClass: 'text-right' },
      ],
      loadBtnAdd: true,

      selFclDate: [],
      dateFCL: [],
      dateFclReq: null,

      selLclDate: [],
      dateLCL: [],
      dateLclReq: null,

      //charge table
      Fcl20ChargeList:[],
      Fcl40ChargeList:[],
      FclChargeFields: [
        { key: 'fcL_THC', label: 'THC', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_Cleaning', label: 'Cleaning', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_SealFee', label: 'Seal Fee', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_TelexFeePerSet', label: 'Telex Fee', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_HandingPerSet', label: 'Handling', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_DOPerSet', label: 'D/O', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_DryContainer', label: 'Customs Clearance Dry Container (BKK)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_ServiceChargePerShipment', label: 'Service Charge', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_ApplyPyotoCOPerShipment', label: 'Apply Pyoto / Apply C/O', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_ApplyFormEPerShipment', label: 'Apply Form E', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'fcL_Trucking', label: 'Trucking', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'fcL_OtherCharge', label: 'Other charges', thClass: 'text-center', tdClass: 'text-center' },
      ],

      LclChargeList:[],
      LclChargeFields: [
        { key: 'lcL_THCPerCBM', label: 'THC', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_CFSPerCBM', label: 'CFS', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_StatusFeePerCBM', label: 'Status Fee', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_CleaningPerCBM', label: 'Cleaning', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_PCSPerCBM', label: 'PCS', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_DOPerSet', label: 'D/O', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_SurrenderBLPerSet', label: 'Surrender B/L', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_HCPerShipment', label: 'H/C', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_OtherChargeLocal', label: 'Other charges', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'lcL_DryContainerPerShipment', label: 'Customs Clearance Dry Container (BKK)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_ServiceChargePerShipment', label: 'Service Charge', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_ApplyPyotoCOPerShipment', label: 'Apply Pyoto / Apply C/O', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_ApplyFormEPerShipment', label: 'Apply Form E', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'lcL_Trucking', label: 'Trucking', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'lcL_OtherChargeExport', label: 'Other charges', thClass: 'text-center', tdClass: 'text-center' },
      ],
      //Charge
      priceDateCharge: new Date(),
      thc: null,
      cleaning: null,
      doC: null,
      dryContainer: null,
      serviceCharge: null,
      applyPyotoCO: null,
      applyFormE: null,

      //charge fcl adj
      sealFee: null,
      telexFee: null,
      handing: null,

      //charge lcl adj
      cfs: null,
      statusFee: null,
      pcs: null,
      surrenderBL: null,
      hc: null,

      // date
      selFclChargeDate: [],
      dateFCLCharge: [],
      dateFclChargeReq: null,

      selLclChargeDate: [],
      dateLCLCharge: [],
      dateLclChargeReq: null,
    };
  },

  created() {
    this.getDateFCL()
    this.getDateLCL()
    this.getDateFCLCharge()
    this.getDateLCLCharge()
  },

  methods: {
    formatDate_dmy,
    formatDate_thaiToEng,
    formatDate_eng,
    format_price,
    isNumberWithDot,
    async getDateFCL() {
        let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/date-FCL-LCL',
        "https://localhost:5001/FCLAndLCL/date-FCL-LCL",
        {
          "container": "FCL"
        },
        { headers: header_token }
      );
      this.selFclDate = formatDate_dmy(response.data.dateTime[0])
      this.dateFclReq = formatDate_eng(response.data.dateTime[0])
      await response.data.dateTime.forEach((e) => {
        this.dateFCL.push({
          date: formatDate_dmy(e)
        })
      });
      this.getFCL20()
      this.getFCL40()
    },

    async getDateLCL() {
        let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/date-FCL-LCL',
        "https://localhost:5001/FCLAndLCL/date-FCL-LCL",
        {
          "container": "LCL"
        },
        { headers: header_token }
      );
      this.selLclDate = formatDate_dmy(response.data.dateTime[0])
      this.dateLclReq = formatDate_eng(response.data.dateTime[0])
      await response.data.dateTime.forEach((e) => {
        this.dateLCL.push({
          date: formatDate_dmy(e)
        })
      });
      this.getLCL()
    },

    async addFcl() {
      if (this.pol == null || this.pod == null || this.ofGP == null || this.ofUsd == null || this.ofThb == null|| this.chargeBkk == null || this.chargeSea == null || this.fclType == null) {
        this.$swal({
          title: 'ข้อมูลไม่ครบ',
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
      } else if ( this.ofGP == '' || this.ebsCicEcrs == '' || this.ofUsd == '' || this.ofThb == '' || this.chargeBkk == '' || this.chargeSea == '') {
        this.$swal({
          title: 'ข้อมูลไม่ครบ',
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
      } else {
        this.loadBtnAdd = false
        let response = await axios.post(
          // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
          "https://localhost:5001/FCLAndLCL/add-FCL",
          {
            "pol": this.pol.city,
            "pod": this.pod.city,
            "ofgp": Number(this.ofGP),
            "ebs": Number(this.ebsCicEcrs),
            "ofusd": Number(this.ofUsd),
            "ofthb": Number(this.ofThb),
            "chargeBKK": Number(this.chargeBkk),
            "exportCharge": Number(this.chargeSea),
            "priceDate": this.priceDate,
            "container": "FCL",
            "containerSize": this.fclType
          },
          { headers: header_token }
        );
        if (response.data.message == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'เพิ่มข้อมูลสำเร็จ',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.getFCL20()
          this.getFCL40()

          this.pol = null
          this.pod = null
          this.ofGP = null
          this.ebsCicEcrs = null
          this.ofUsd = null
          this.ofThb = null
          this.chargeBkk = null
          this.chargeSea = null
          this.priceDate = new Date()
          this.container = null
          this.fclType = null
        }
        this.loadBtnAdd = true
      }
    },

    async addLcl() {
      if (this.pol == null || this.pod == null || this.ofThb == null|| this.chargeBkk == null || this.chargeSea == null) {
        this.$swal({
          title: 'ข้อมูลไม่ครบ',
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
      } else if ( this.ofThb == '' || this.chargeBkk == '' || this.chargeSea == '') {
        this.$swal({
          title: 'ข้อมูลไม่ครบ',
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
      } else {
        this.loadBtnAdd = false
        let response = await axios.post(
          // taobaoService_dotnet + 'FCLAndLCL/add-LCL',
          "https://localhost:5001/FCLAndLCL/add-LCL",
          {
            "pol": this.pol.city,
            "pod": this.pod.city,
            "ofthb": Number(this.ofThb),
            "localCharge": Number(this.chargeBkk),
            "exportCharge": Number(this.chargeSea),
            "priceDate": this.priceDate,
            "container": "LCL",
          },
          { headers: header_token }
        );
        if (response.data.message == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'เพิ่มข้อมูลสำเร็จ',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.getLCL()

          this.pol = null
          this.pod = null
          this.ofThb = null
          this.chargeBkk = null
          this.chargeSea = null
          this.priceDate = new Date()
          this.container = null
        }
        this.loadBtnAdd = true
      }
    },

    async getFCL20(dateReq) {
      let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
        "https://localhost:5001/FCLAndLCL/get-FCL-LCL",
        {
          "container": "FCL",
          "priceDate": dateReq == undefined ? this.dateFclReq : formatDate_thaiToEng(dateReq.date),
          "containerSize": "20"
        },
        { headers: header_token }
      );
      this.Fcl20List = response.data
    },

    async getFCL40(dateReq) {
      let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
        "https://localhost:5001/FCLAndLCL/get-FCL-LCL",
        {
          "container": "FCL",
          "priceDate": dateReq == undefined ? this.dateFclReq :  formatDate_thaiToEng(dateReq.date),
          "containerSize": "40"
        },
        { headers: header_token }
      );
      this.Fcl40List = response.data
    },

    async getLCL(dateReq) {
      let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
        "https://localhost:5001/FCLAndLCL/get-FCL-LCL",
        {
          "container": "LCL",
          "priceDate": dateReq == undefined ? this.dateLclReq : formatDate_thaiToEng(dateReq.date),
          "containerSize": "20"
        },
        { headers: header_token }
      );
      this.LclList = response.data
    },

    async addFCLCharge() {
      if (this.thc == null || this.cleaning == null || this.sealFee == null || this.telexFee == null || this.handing == null || this.doC == null || this.dryContainer == null || this.serviceCharge == null|| this.applyPyotoCO == null || this.applyFormE == null || this.fclType == null ) {
        this.$swal({
          title: 'ข้อมูลไม่ครบ',
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
      } else if ( this.thc == '' || this.cleaning == '' || this.sealFee == '' || this.telexFee == '' || this.handing == '' || this.doC == '' || this.dryContainer == '' || this.serviceCharge == '' || this.applyPyotoCO == '' || this.applyFormE == '' ) {
        this.$swal({
          title: 'ข้อมูลไม่ครบ',
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
      } else {
        this.loadBtnAdd = false
        let response = await axios.post(
          // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
          "https://localhost:5001/FCLAndLCL/add-FCL-charge",
          {
            "priceDate": this.priceDateCharge,
            "thc": this.thc,
            "cleaning": this.cleaning,
            "sealFee": this.sealFee,
            "telexFee": this.telexFee,
            "handing": this.handing,
            "do": this.doC,
            "dryContainer": this.dryContainer,
            "serviceCharge": this.serviceCharge,
            "applyPyotoCO": this.applyPyotoCO,
            "applyFormE": this.applyFormE,
            "container": "FCL",
            "containerSize": this.fclType
          },
          { headers: header_token }
        );
        if (response.data.message == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'เพิ่มข้อมูลสำเร็จ',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.getFcl20Charge()

          this.priceDateCharge = new Date()
          this.thc = null
          this.cleaning = null
          this.sealFee = null
          this.telexFee = null
          this.handing = null
          this.doC = null
          this.dryContainer = null
          this.serviceCharge = null
          this.applyPyotoCO = null
          this.applyFormE = null
          this.fclType = null
        }
        this.loadBtnAdd = true
      }
    },

    async addLCLCharge() {
      if ( this.thc == null || this.cfs == null || this.statusFee == null || this.cleaning == null || this.pcs == null || this.doC == null || this.surrenderBL == null || this.hc == null || this.dryContainer == null || this.serviceCharge == null|| this.applyPyotoCO == null || this.applyFormE == null ) {
        this.$swal({
          title: 'ข้อมูลไม่ครบ',
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
      } else if ( this.thc == '' || this.cfs == '' || this.statusFee == '' || this.cleaning == '' || this.pcs == '' || this.doC == '' || this.surrenderBL == '' || this.hc == '' || this.dryContainer == '' || this.serviceCharge == '' || this.applyPyotoCO == '' || this.applyFormE == '' ) {
        this.$swal({
          title: 'ข้อมูลไม่ครบ',
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
      } else {
        this.loadBtnAdd = false
        let response = await axios.post(
          // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
          "https://localhost:5001/FCLAndLCL/add-LCL-charge",
          {
            "priceDate": this.priceDateCharge,
            "thc": this.thc,
            "cfs": this.cfs,
            "statusFee": this.statusFee,
            "cleaning": this.cleaning,
            "pcs": this.pcs,
            "do": this.doC,
            "surrenderBL": this.surrenderBL,
            "hc": this.hc,
            "dryContainer": this.dryContainer,
            "serviceCharge": this.serviceCharge,
            "applyPyotoCO": this.applyPyotoCO,
            "applyFormE": this.applyFormE,
            "container": "LCL"
          },
          { headers: header_token }
        );
        if (response.data.message == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'เพิ่มข้อมูลสำเร็จ',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })

          this.priceDateCharge = new Date()
          this.thc = null
          this.cfs = null
          this.statusFee = null
          this.cleaning = null
          this.pcs = null
          this.doC = null
          this.surrenderBL = null
          this.hc = null
          this.dryContainer = null
          this.serviceCharge = null
          this.applyPyotoCO = null
          this.applyFormE = null
        }
        this.loadBtnAdd = true
      }
    },

    async getDateFCLCharge() {
      let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/date-Charge',
        "https://localhost:5001/FCLAndLCL/date-Charge",
        {
          "container": "FCL"
        },
        { headers: header_token }
      );
      this.selFclChargeDate = formatDate_dmy(response.data.dateTime[0])
      this.dateFclChargeReq = formatDate_eng(response.data.dateTime[0])
      await response.data.dateTime.forEach((e) => {
        this.dateFCLCharge.push({
          date: formatDate_dmy(e)
        })
      });
      this.getFcl20Charge()
      this.getFcl40Charge()
    },

    async getDateLCLCharge() {
      let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/date-Charge',
        "https://localhost:5001/FCLAndLCL/date-Charge",
        {
          "container": "LCL"
        },
        { headers: header_token }
      );
      this.selLclChargeDate = formatDate_dmy(response.data.dateTime[0])
      this.dateLclChargeReq = formatDate_eng(response.data.dateTime[0])
      await response.data.dateTime.forEach((e) => {
        this.dateLCLCharge.push({
          date: formatDate_dmy(e)
        })
      });
      this.getLclCharge()
    },

    async getFcl20Charge(dateReq) {
      let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
        "https://localhost:5001/FCLAndLCL/get-charge",
        {
          "container": "FCL",
          "priceDate": dateReq == undefined ? this.dateFclChargeReq : formatDate_thaiToEng(dateReq.date),
          "containerSize": "20"
        },
        { headers: header_token }
      );
      this.Fcl20ChargeList = response.data
    },

    async getFcl40Charge(dateReq) {
      let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
        "https://localhost:5001/FCLAndLCL/get-charge",
        {
          "container": "FCL",
          "priceDate": dateReq == undefined ? this.dateFclChargeReq : formatDate_thaiToEng(dateReq.date),
          "containerSize": "40"
        },
        { headers: header_token }
      );
      this.Fcl40ChargeList = response.data
    },

    async getLclCharge(dateReq) {
      let response = await axios.post(
        // taobaoService_dotnet + 'FCLAndLCL/add-FCL',
        "https://localhost:5001/FCLAndLCL/get-charge",
        {
          "container": "LCL",
          "priceDate": dateReq == undefined ? this.dateLclChargeReq : formatDate_thaiToEng(dateReq.date),
        },
        { headers: header_token }
      );
      console.log("lcl charge: ", response.data);
      this.LclChargeList = response.data
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>